/**
 * @flow
 * @relayHash 8ec12ae6324c71def9bb086c470db01b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteOrderYieldInput = {|
  id: string
|};
export type DeleteOrderYieldMutationVariables = {|
  input: DeleteOrderYieldInput
|};
export type DeleteOrderYieldMutationResponse = {|
  +deleteOrderYield: {|
    +deletedId: string
  |}
|};
export type DeleteOrderYieldMutation = {|
  variables: DeleteOrderYieldMutationVariables,
  response: DeleteOrderYieldMutationResponse,
|};
*/


/*
mutation DeleteOrderYieldMutation(
  $input: DeleteOrderYieldInput!
) {
  deleteOrderYield(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteOrderYieldInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteOrderYield",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteOrderYieldPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteOrderYieldMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteOrderYieldMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteOrderYieldMutation",
    "id": null,
    "text": "mutation DeleteOrderYieldMutation(\n  $input: DeleteOrderYieldInput!\n) {\n  deleteOrderYield(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd509d1d11a4dc159a40be0f34221ec30';
module.exports = node;
